var map = {
	"./copy-icon.svg": "54dc",
	"./document-add-icon.svg": "2955",
	"./empty.svg": "667f",
	"./info-circle-icon.svg": "f63f",
	"./info-icon-fill.svg": "bb93",
	"./info-icon.svg": "b272",
	"./login-out.svg": "f1b9",
	"./mail-icon.svg": "c24c",
	"./menu-contact.svg": "96e0",
	"./menu-dashboard.svg": "c7df",
	"./menu-extend.svg": "3e0b",
	"./menu-ib-accounts.svg": "c4c5",
	"./menu-levels.svg": "6509",
	"./menu-links.svg": "2f2f",
	"./menu-profile.svg": "8372",
	"./menu-report.svg": "ddbb",
	"./menu-transfer-history.svg": "7518",
	"./register/ibtRegister-complete-icon.svg": "66b4",
	"./register/ibtRegister-financial-icon.svg": "c8bb",
	"./register/ibtRegister-poa-icon.svg": "9869",
	"./register/ibtRegister-poi-icon.svg": "2608",
	"./user-icon.svg": "2272"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "f853";